import { CloseIcon } from "./CloseIcon";

export const CommentHeader = ({ open }) => (
  <header className="flex flex-col gap-6 items-start pb-4 w-full border border-gray-200">
    <div className="flex flex-col gap-6 items-start py-0 pr-3 pl-6 w-full">
      <div className="flex gap-4 items-start pt-6 w-full">
        <h1 className="flex-1 gap-0.5 w-full text-xl font-semibold leading-8 text-gray-900">
          Comments
        </h1>
        <button
          className="flex relative bottom-0.5 right-4 justify-center items-center p-2 w-10 h-10 rounded-lg cursor-pointer"
          onClick={() => open(false)}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  </header>
);
